export default __webpack_public_path__ + "static/media/004-fishing.c2ed995d.svg";